export const fallbackLng = "en";
export const germanLng = "de";
export const languages = [
    fallbackLng,
    germanLng
];
export const defaultNS = "translation";
export const cookieName = "i18next";
export function getOptions() {
    let lng = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fallbackLng, ns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultNS;
    return {
        // debug: true,
        supportedLngs: languages,
        fallbackLng,
        lng,
        fallbackNS: defaultNS,
        defaultNS,
        ns
    };
}
export const i18n = {
    defaultLocale: "en",
    locales: [
        "en",
        "de"
    ]
};
